// export const credlixAgentConfig = {
//   baseUrl: "https://voxera.credlix.com",
//   apiKey: "vx_aee3bb91e9c14c19",
//   apiSecret: "vx_cs_Qm5YcsOIkHM5EnItxiJlk0FlgoP_-ul1",
//   workflowId: "group_8s0x6",
//   outboundWorkflowId: "group_8s0x6",
//   token: "",
//   connectWithRealAgent: true,
//   userName: "Abhishek",
//   phoneNumber: "9598986100",
//   agentName: "Abhishek Mall",
//   agentPhone: "+910000000000",
//   agentEmail: "abhishek.mall@credlix.com",
//   chatTitle: "Voxera Support",
//   callBtnText: "Talk to RM",
//   renderWidget: true,
//   showNotifications: true,
//   connectToMeOnly: true,
// };

// export default credlixAgentConfig;



// export const credlixAgentConfig = {
//   baseUrl: "https://voxera-qa.credlixlab.com/",
//   apiKey: "vx_23b453c2aa08441a",
//   apiSecret: "vx_cs_OJQshi14GRSucpx59iEVGFLeokXQl35S",
//   workflowId: "group_gvljl",
//   connectWithRealAgent: true,
//   userName: "Abhishek",
//   phoneNumber: "9598986100",
//   agentName: "Abhishek Mall",
//   agentPhone: "+910000000000",
//   callBtnText: "Talk to RM",
//   renderWidget: true,
//   showNotifications: true,
//   connectToMeOnly: true,
// };

// export default credlixAgentConfig;

const isImportFactoring = () => {
  if (typeof window === "undefined") return false;
  const pathname = window.location.pathname || "";
  return (
    pathname.includes("import-factoring") ||
    pathname.includes("import-factoring-apply")
  );
};

export const credlixAgentConfig = {
  baseUrl: process.env.VOXERA_BASE_URL,
  apiKey: process.env.VOXERA_APIKEY,
  apiSecret: process.env.VOXERA_APISECRET,
  workflowId: process.env.VOXERA_WORKFLOWId,
  eximWorkflowId: process.env.EXIM_AI_VOXERA_WORKFLOWId,
  connectWithRealAgent: true,
  userName: isImportFactoring()
    ? process.env.VOXERA_EXIM_AGENT_NAME
    : process.env.VOXERA_AGENT_NAME,
  phoneNumber: isImportFactoring()
    ? process.env.VOXERA_EXIM_PHONE_NUMBER
    : process.env.VOXERA_PHONE_NUMBER,
  agentName: isImportFactoring()
    ? process.env.VOXERA_EXIM_AGENT_NAME
    : process.env.VOXERA_AGENT_NAME,
  agentPhone: "+910000000000",
  callBtnText: "Talk to RM",
  renderWidget: true,
  showNotifications: true,
  connectToMeOnly: true,
};

export default credlixAgentConfig;